// 2023.07.27
// - rename from 'car.routes.js' to 'standard.routes.js'
import {h, KeepAlive} from 'vue'
import {RouterView} from 'vue-router'

export const StandardRoutes = [
  {
    path: '/car/:id',
    component: () => import('@pages/standard/index.vue'),
    meta: {
      title: '精品自营车',
    },
    children: [
      // car/:id
      // - 自营车详情
      // - 2023.06.12
      // - file: @pages/carDetail → @pages/standard-detail
      {
        path: '',
        name: 'carDetail',
        component: () => import('@pages/standard-detail/index.vue'),
        meta: {},
      },

      // car/:id/photos
      // - 自营车图片
      // - 2023.06.12
      // - file: @pages/carPhotos → @pages/standard-photo
      {
        path: 'photos',
        name: 'carPhotos',
        component: () => import('@pages/standard-photo/index.vue'),
        meta: {},
      },

      // /car/:id/loans
      // - 自营车按揭
      // - 2023.06.12
      // - file: @pages/carLoans → @pages/standard-mortgage
      {
        path: 'loans',
        name: 'carLoans',
        component: () => import('@pages/standard-mortgage/index.vue'),
        meta: {},
      },

      // /car/:id/video
      // - 自营车视频
      // - 2023.06.12
      // - file: @pages/carVideo → @pages/standard-video
      {
        path: 'video',
        name: 'carVideo',
        component: () => import('@pages/standard-video/index'),
        meta: {},
      },

      // /car/:id/faq
      // - FAQ详情页
      // - 2025.07.25
      // - FAQ detail page showing all questions and answers
      {
        path: 'faq',
        name: 'FaqDetail',
        component: () => import('@pages/faq-detail/index.vue'),
        meta: {
          title: '我想问问',
        },
      },

      // 诺式报告
      // - report
      {
        path: 'report',
        component: RouterView,
        children: [
          // StandardReportMileage
          // - 2023.06.12
          // - 维保记录/里程曲线
          // - car/:id/report/mileage
          // - car/:id/mileage
          {
            path: 'mileage',
            alias: ['/car/:id/mileage'],
            name: 'StandardReportMileage',
            component: () => import('@pages/standard-report-mileage/index'),
            meta:{
              title: '维保记录',
            },
          },

          // StandardReportAccessory
          // - 2022.05.10
          // - 附件清单
          // - car/:id/report/accessory
          // - car/:id/accessory
          {
            path: 'accessory',
            alias: ['/car/:id/accessory'],
            name: 'StandardReportAccessory',
            component: () => import('@pages/standard-report-accessory'),
            meta: {
              title: '附件清单',
            },
          },

          // StandardReportConsumble
          // - 2022.06.13
          // - 耗材清单
          {
            path: 'consumable',
            alias: ['/car/:id/consumable'],
            name: 'StandardReportConsumble',
            component: () => import('@pages/standard-report-consumable'),
            meta: {
              title: '耗材清单',
            },
          },

          // 诺式报告-售前整备清单
          // StandardReportPreparation
          // - 2022.06.13
          // - 售前整备清单
          {
            path: 'preparation',
            component: {
              render () {
                return h(RouterView, null, {
                  default: ({Component}) => h(KeepAlive, null, {
                    default: () => h(Component),
                  }),
                })
              },
            },
            children: [
              {
                path: '',
                name: 'StandardReportPreparation',
                component: () => import('@pages/standard-report-preparation'),
                meta:{},
              },
              {
                path: 'remind',
                name: 'StandardReportPreparationRemind',
                component: () => import('@pages/standard-report-preparation-remind'),
                meta:{},
              },
            ],
          },

          // StandardReportFlaw
          // - 2023.06.21
          // - 主要瑕疵（瑕疵报告）
          // - 2025.10.28
          // - rename to “外观瑕疵”
          {
            path: 'flaw',
            name: 'StandardReportFlaw',
            component: () => import('@pages/standard-report-flaw/index.vue'),
            meta: {
              title: '外观瑕疵',
            },
          },

          // StandardReportChassis
          // - 2023.06.21
          // - 底盘照片
          {
            path: 'chassis',
            name: 'StandardReportChassis',
            component: () => import('@pages/standard-report-chassis/index.vue'),
            meta: {
              title: '底盘照片',
            },
          },

          // StandardReportRefurbishList
          // - 2024.09.19
          // - 诺式整备清单
          {
            path: 'refurbish-list',
            name: 'StandardReportRefurbishList',
            component: () => import('@pages/standard-report-refurbish-list/index.vue'),
            meta: {
              title: '诺式整备单',
            },
          },

          // name report
          {
            path: ':name',
            name: 'CarCategroyReport',
            component: () => import('@pages/standard-report/index.vue'),
            meta: {},
          },
        ],
      },

      // internal/video
      // - 内部，内外观视频
      {
        path: 'internal/video',
        name: 'StandardInternalVideo',
        component: () => import('@pages/standard-internal-video'),
        meta: {
          title: '内外观视频',
        },
      },

      // benchmark
      {
        path: 'benchmark',
        name: 'StandardBenchmark',
        component:  () => import('@pages/standard-benchmark'),
        meta: {
          title: 'benchmark',
        },
      },

      // exterior-video
      // - 2023.06.12
      // - exterior video "绕车视频"
      {
        path: 'exterior-video',
        name: 'StandardExteriorVideo',
        component: () => import('@pages/standard-exterior-video'),
        meta: {
          title: '绕车视频',
        },
      },

      // appriase
      // - 2023.06.12
      // - 二鉴报告
      // - example: /car/7534/appraise (develpment)
      {
        path: 'appraise',
        name: 'CarAppraiseReport',
        component: () => import('@pages/standard-report-appraise'),
        meta: {
          title: '二鉴报告',
        },
      },

      // report-inspection
      // - 2024.03.27
      // - 二手车鉴定报告
      // - example: /car/<carId>/report-inspection/<reportId>/business/<business>
      //   e.g Production: http://localhost:3000/car/ak1TQmE3Q3ZuMFU9/report-inspection/2/business/zyc?mode=preview
      {
        path: 'report-inspection/:reportId/business/:business',
        name: 'CarReportInspection',
        component: () => import('@pages/report-inspection/index'),
        children: [
          {
            path: '',
            name: 'CarReportInspectionIndex',
            component: () => import('@pages/report-inspection/default'),
            meta: {
              title: '二手车鉴定报告',
            },
          },
          {
            path: 'inspection-checklist',
            name: 'CarReportInspectionChecklist',
            component: () => import('@pages/report-inspection-checklist/index'),
            meta: {
              title: '全车检查点',
            },
          },
          {
            path: 'inspection-checklist-table',
            name: 'CarReportInspectionChecklistTable',
            component: () => import('@pages/report-inspection-checklist-table/index'),
            meta: {
              title: '全车检查点表格',
            },
          },
          {
            path: 'inspection-checklist-detail',
            name: 'CarReportInspectionChecklistDetail',
            component: () => import('@pages/report-inspection-checklist-detail/index'),
            meta: {
              title: '检查点详情',
            },
          },
          {
            path: 'maintenance-record',
            name: 'CarReportInspectionMaintenanceRecord',
            component: () => import('@pages/report-inspection-maintenance-record/index'),
            meta: {
              title: '维保记录',
            },
          },
          {
            path: 'mileage-analysis-basis',
            name: 'CarReportInspectionMileageAnalysisBasis',
            component: () => import('@pages/report-inspection-mileage-analysis-basis/index'),
            meta: {
              title: '里程分析依据',
            },
          },
          {
            path: 'accident-record',
            name: 'CarReportInspectionAccidentRecord',
            component: () => import('@pages/report-inspection-accident-record/index'),
            meta: {
              title: '出险记录',
            },
          },
          // 提示（鉴定师备注）
          {
            path: 'report-inspection-notice',
            name: 'CarReportInspectionNotice',
            component: () => import('@pages/report-inspection-notice/index'),
            meta: {
              title: '提示',
            },
          },
        ],
      },

      // report-inspection-preview
      // - 2025.05.16
      // - 二鉴报告(抢先)
      // - example: /car/<carId>/report-inspection-preview/<reportId>/business/<business>
      {
        path: 'report-inspection-preview/:reportId/business/:business',
        name: 'CarReportInspectionPreview',
        component: () => import('@pages/report-inspection-preview/index'),
        meta: {
          title: '二手车鉴定报告(抢先)',
        },
      },
    ],
  },
  {
    path: '/discount',
    name: 'StandardDiscount',
    component: () => {
      return import('@pages/standard-list/index.vue')
    },
    props: {
      category: 'discount',
      pageTitle: '特价区',
      shareTitle: '特价区｜爱车的诺诺',
    },
    meta: {
      title: '特价区',
    },
  },
]
